/**
 * Kbd — tiny keycap chip (Story UI-U2, port of the prototype kbd.tsx pattern).
 *
 * Small, lightly rounded, monospace, muted — gives orientation without
 * distracting (no strong contrast). Semantic token classes only.
 *
 * [Source: brokly-design-reference/components/brokly/kbd.tsx]
 * [Source: brokly-design-reference/lib/shortcuts.ts] (isMac / cmdSymbol)
 */

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

/** macOS detection so shortcut hints show ⌘ instead of Ctrl. Safe default: not a Mac. */
export function isMac(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent);
}

/** Platform display symbol for the command/control modifier. */
export function cmdSymbol(): string {
  return isMac() ? '⌘' : 'Ctrl';
}

export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      className={cn(
        'inline-flex h-[1.125rem] min-w-[1.125rem] select-none items-center justify-center rounded border border-border bg-muted px-1 font-mono text-[10px] font-medium text-muted-foreground',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
